export const EDIT_SUCCESS = 'Страна обновлена';
export const EDIT_ERROR = 'Не удалось обновить страну';
